module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.finalMessage != null),
      expression: "finalMessage != null"
    }],
    class: 'alert alert-' + _vm.type,
    domProps: {
      "innerHTML": _vm._s(_vm.finalMessage)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cada018e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Content/Modern/js/vue/_alert-message.vue
// module id = 123
// module chunks = 1